import { useState } from 'react';
import { AddressFormField } from '../../puck/reusable-props/addressFormOptions';
import { option } from './ShippingForm';
import { IAddressOptions, IFieldOption } from '../../interface/formInterface';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const AddressHelper = ({
  value,
  onChange,
  name,
}: {
  value: option | IFieldOption;
  onChange: (_value: option | IFieldOption) => void;
  name: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{name}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          {Object?.keys(value || {})?.map((key, index) => {
            if (name === 'Billing Form' && key === 'Phone') return null; // Skip the phone field
            return (
              <AddressFormField
                index={index}
                formName={name}
                key={key}
                name={key}
                value={
                  value?.[key as keyof IFieldOption] ?? ({} as IAddressOptions)
                }
                onChange={newValue => onChange({ ...value, [key]: newValue })}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default AddressHelper;
